import React from 'react';
import { trackEvent, BOOKING_SCREENING_URL } from '../lib/tracking';

export default function ProcessSection() {
  const steps = [
    {
      num: '1',
      title: 'Gratis afklaringssamtale (20 min.)',
      subtitle: 'Telefonisk eller online',
      desc: 'Vi tager en uforpligtende samtale om, hvad du oplever, og hvad du ønsker hjælp til. Du mærker efter, om kemien og tilliden er til stede, helt uden forpligtelse til et videre forløb.',
      icon: 'fa-solid fa-comments',
    },
    {
      num: '2',
      title: 'Første session (60 min.)',
      subtitle: 'På Amager eller online',
      desc: 'Vi dykker dybere ned i dine mønstre, udløsere og ressourcer i et trygt og ufordømmende rum. Sammen lægger vi en realistisk og overskuelig plan for dit forløb.',
      icon: 'fa-solid fa-compass',
    },
    {
      num: '3',
      title: 'Dit videre forløb',
      subtitle: 'I dit eget tempo',
      desc: 'Forløbet tilpasses løbende. Vi kombinerer samtale, kropslig regulering og eventuelt hypnose for at skabe varig forandring, indre ro og balance.',
      icon: 'fa-solid fa-seedling',
    },
  ];

  return (
    <section className="py-20 sm:py-24 bg-white border-y border-[#D9DDE2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14 sm:mb-16">
          <span className="text-xs uppercase tracking-widest font-semibold text-[#5A232E] block mb-3">
            Enkel proces
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#5A232E] tracking-tight">
            Sådan foregår et terapeutisk forløb
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#6c7480] leading-relaxed">
            Vejen til forandring starter med et lille, trygt skridt. Her er hvad du kan forvente fra første henvendelse.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 relative">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className="bg-[#ECEEF1] rounded-2xl p-8 border border-[#D9DDE2] relative flex flex-col justify-between hover:border-[#5A232E]/40 transition-colors"
            >
              <div>
                <div className="flex items-center justify-between mb-6">
                  <div className="w-12 h-12 rounded-2xl bg-[#5A232E] text-white flex items-center justify-center font-display font-bold text-xl shadow-xs">
                    {step.num}
                  </div>
                </div>

                <h3 className="font-display text-xl text-[#5A232E] mb-1">
                  {step.title}
                </h3>
                <div className="text-xs font-semibold uppercase tracking-wider text-[#5A232E] mb-3">
                  {step.subtitle}
                </div>
                <p className="text-sm text-[#6c7480] leading-relaxed">
                  {step.desc}
                </p>
              </div>

              <div className="mt-6 pt-4 border-t border-[#D9DDE2]/60 text-xs text-[#5A232E] flex items-center gap-1.5 font-medium">
                <i className="fa-solid fa-check text-emerald-600" aria-hidden="true" />
                <span>100% fortroligt og trygt</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href={BOOKING_SCREENING_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('cta_booking_click', { location: 'process_section' })}
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-[#5A232E] hover:bg-[#431722] text-white font-semibold text-sm shadow-md hover:shadow-lg transition-all transform hover:-translate-y-0.5 no-break whitespace-nowrap"
          >
            <i className="fa-solid fa-calendar-check" aria-hidden="true" />
            <span>Book din gratis afklaringssamtale nu</span>
          </a>
        </div>
      </div>
    </section>
  );
}
